module.exports = __webpack_public_path__ + "img/qjgk.66a3d773.png";